<!-- <header-bar></header-bar>
<ng-progress
  [spinner]="false"
  [meteor]="false"
  [color]="'#FFF'"
  direction="rightToLeftIncreased">
</ng-progress> -->
<router-outlet></router-outlet>
<version-bar></version-bar>
